import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  farmerProfile: {},
  status: 'idle',
  error: null,
};

export const fetchFarmerDetails = createAsyncThunk(
  'fetchFarmerDetails',
  async ({ id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/field-officer/farmer-details/${id}`
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateFarmerProfile = createAsyncThunk(
  'updateFarmerProfile',
  async (
    { email_id, address, pincode, state, city, mobile_no, id },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axiosInstance.put(
        `/field-officer/farmer-details/${id}`,
        {
          email_id,
          address,
          pincode,
          state,
          city,
          mobile_no,
        }
      );
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const farmerProfileSlice = createSlice({
  name: 'farmerProfile',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchFarmerDetails.pending, (state, action) => {
        state.status = 'loading';
      })
      .addCase(fetchFarmerDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.farmerProfile = { ...action.payload.details };
      })
      .addCase(fetchFarmerDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      .addCase(updateFarmerProfile.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateFarmerProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.farmerProfile = { ...action.payload.details };
      })
      .addCase(updateFarmerProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        alert(state.error.msg);
      });
  },
});

export default farmerProfileSlice.reducer;
